<dialog
  class="cmdk-backdrop"
  [appModalOpen]="isOpen()"
  (modalClosed)="close()"
  aria-label="Command palette"
>
  <!-- RF-QA-173: the ~40-option listbox used to be built on first paint of
       every page. The body now renders only while the palette is open; the
       <dialog> shell stays so appModalOpen can showModal() into it. -->
  @if (isOpen()) {
    <div class="cmdk">
      <div class="cmdk__input-row">
        <ui-icon
          name="search"
          size="sm"
          class="cmdk__search-icon"
          aria-hidden="true"
        ></ui-icon>
        <input
          #searchInput
          type="text"
          class="cmdk__input"
          spellcheck="false"
          autocomplete="off"
          autofocus
          role="combobox"
          aria-autocomplete="list"
          [attr.aria-expanded]="isOpen()"
          aria-controls="command-palette-results"
          [attr.aria-activedescendant]="
            results().length ? 'command-palette-option-' + safeIndex() : null
          "
          [value]="query()"
          (input)="onInput($event)"
          (keydown)="onKeydown($event)"
          placeholder="Search symbol, route, or action…"
          aria-label="Search for a command, symbol, or route"
        />
        <button
          type="button"
          class="cmdk__kbd"
          aria-label="Close command palette"
          (click)="close()"
        >
          esc
        </button>
      </div>

      <div
        class="cmdk__results"
        id="command-palette-results"
        role="listbox"
        aria-label="Commands"
      >
        @if (results().length === 0) {
          <p class="cmdk__empty">No matches.</p>
        } @else {
          @for (
            item of results();
            track trackById($index, item);
            let i = $index
          ) {
            <button
              type="button"
              class="cmdk__row"
              [class.is-selected]="i === safeIndex()"
              role="option"
              tabindex="-1"
              [id]="'command-palette-option-' + i"
              [attr.aria-selected]="i === safeIndex()"
              (click)="invokeItem(item)"
            >
              <ui-icon
                [name]="iconForKind(item.kind)"
                size="xs"
                class="cmdk__row-icon"
                aria-hidden="true"
              ></ui-icon>
              <span class="cmdk__row-label">{{ item.label }}</span>
              @if (item.description) {
                <span class="cmdk__row-desc">{{ item.description }}</span>
              }
              @if (item.hotkey) {
                <kbd class="cmdk__kbd cmdk__row-kbd">{{ item.hotkey }}</kbd>
              }
            </button>
          }
        }
      </div>

      <footer class="cmdk__footer">
        <span><kbd class="cmdk__kbd">↑↓</kbd> navigate</span>
        <span><kbd class="cmdk__kbd">↵</kbd> open</span>
        <span
          ><kbd class="cmdk__kbd">{{ modKey }}K</kbd> close</span
        >
      </footer>
    </div>
  }
</dialog>
